import React from 'react';
import { ChevronRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'outline';
  size?: 'lg' | 'xl';
  fullWidth?: boolean;
  className?: string;
}
export function Button({
  children,
  variant = 'primary',
  size = 'lg',
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-display font-bold uppercase tracking-wider transition-all duration-200 rounded-sm';
  const variants = {
    primary: 'bg-brand text-white hover:bg-brand-light shadow-[0_0_20px_rgba(22,163,74,0.4)] hover:shadow-[0_0_30px_rgba(34,197,94,0.6)] hover:-translate-y-1',
    outline: 'border-2 border-brand text-brand hover:bg-brand hover:text-white'
  };
  const sizes = {
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl md:text-2xl'
  };
  return <button className={`
        ${baseStyles} 
        ${variants[variant]} 
        ${sizes[size]} 
        ${fullWidth ? 'w-full' : ''} 
        ${className}
      `} {...props} data-id="element-264">
      {children}
      <ChevronRight className="ml-2 w-6 h-6" strokeWidth={3} data-id="element-265" />
    </button>;
}